"use client";
import { MessageFilled, MessageOutlined } from "@ant-design/icons";

import PopoverPrimary, {
  type PopoverPrimaryProps,
} from "@/components/molecules/popover/mounted/primary";

import { useTalkToSpecialistContext } from "../mounted-molecules/talk-to-specialist-modal/context";

export default function MenuMobile() {
  const { setOpen } = useTalkToSpecialistContext();

  const items: PopoverPrimaryProps["items"] = [
    {
      icons: {
        filled: <MessageFilled />,
        outlined: <MessageOutlined />,
      },
      onClick: () => setOpen(true),
      label: "Falar com especialista",
    },
  ];
  return (
    <div className="block md:hidden">
      <PopoverPrimary items={items} offset={6} />
    </div>
  );
}
